import { type ReactNode } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ConsoleShell } from "../components/ConsoleShell";
import { CommandPalette } from "../components/CommandPalette";
import { DetailDrawers } from "../components/DetailDrawers";
import { ConsoleModals } from "../components/ConsoleModals";

import Dashboard from "../pages/Dashboard";
import Namespaces from "../pages/Namespaces";
import CreateNamespace from "../pages/CreateNamespace";
import Query from "../pages/Query";
import MultiQuery from "../pages/MultiQuery";
import Documents from "../pages/Documents";
import Operations from "../pages/Operations";
import Compaction from "../pages/Compaction";
import Analytics from "../pages/Analytics";
import Repos from "../pages/Repos";
import Jobs from "../pages/Jobs";
import Keys from "../pages/Keys";
import Embedders from "../pages/Embedders";
import WorkspacePage from "../pages/WorkspacePage";
import SuperAdmin from "../pages/SuperAdmin";
import Settings from "../pages/Settings";
import Billing from "../pages/Billing";

/**
 * The seventeen console screens, plus the overlays that can appear over any of
 * them. Mounted twice — once by LiveRoot at "/" and once by DevRoot at "/dev" —
 * with `useHref()`/`useGo()` resolving links against the active base.
 */
export default function ConsoleRoutes({ devBar }: { devBar?: ReactNode }) {
  return (
    <ConsoleShell devBar={devBar}>
      <Routes>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="namespaces" element={<Namespaces />} />
        <Route path="namespaces/new" element={<CreateNamespace />} />
        <Route path="query" element={<Query />} />
        <Route path="multi-query" element={<MultiQuery />} />
        <Route path="documents" element={<Documents />} />
        <Route path="operations" element={<Operations />} />
        <Route path="compaction" element={<Compaction />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="repos" element={<Repos />} />
        <Route path="jobs" element={<Jobs />} />
        <Route path="keys" element={<Keys />} />
        <Route path="embedders" element={<Embedders />} />
        <Route path="workspace" element={<WorkspacePage />} />
        <Route path="superadmin" element={<SuperAdmin />} />
        <Route path="settings" element={<Settings />} />
        <Route path="billing" element={<Billing />} />
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Routes>

      <DetailDrawers />
      <ConsoleModals />
      <CommandPalette />
    </ConsoleShell>
  );
}
